<template>
  <aside class="cart-section">

    <span class="background" @click="$parent.isCartOpen = false"></span>

    <div class="wrap"> 

      <h3>CART</h3>

      <button
        class="close"
        @click="$parent.isCartOpen = false"
      >
        <span class="material-icons-outlined">close</span>
      </button>

      <div v-if="cart.summary.items_count == 0">
        <p>Your cart is empty</p>
      </div>
        
      <div
        v-else
        class="list"
      >
  
        <article
          v-for="(item, index) in cart.items"
          :key="index"
          class="md:flex md:align-center"
        >
          <div class="product flex align-center">
            <img
              :src="item.image"
              :alt="item.title"
              class="hero"
            >

            <div class="info">
              <h5>{{ item.title }}</h5>
              <!-- <a
                class="remove"
                @click="removeCartItem(index, item.key, item.title)"
              >
                Remove
              </a> -->
            </div>
          </div>
           
          <div class="flex align-center">
            <div class="quantity">
              <div class="quantity-wrap">
                <button
                  @click="updateQuantity('-', index)"
                  :disabled="item.qty < 0"
                >
                  <span class="icon-minus2"></span>
                </button>
                <input
                  type="number"
                  v-model="cart.items[index].qty"
                >
                <button
                  @click="updateQuantity('+', index)"
                >
                  <span class="icon-plus2"></span>
                </button>
              </div>
            </div>

            <div class="price">
              <p><span>$</span>{{ modFormatAmount(modCalculateTotalAmount(item.qty, item.price, false)) }}</p>
            </div>
          </div>
        </article>

      </div>
        
      <cart-summary
        :showProceed="true"
      ></cart-summary>
    </div>

  </aside>
</template>

<script>
export default {
  props: {
    initCart: Object  
  },
  
  data () {
    return {
      removeButton: false,
      quantityInput: false,
    }
  },
  
  mounted () {
    this.$store.commit('setCart', this.initCart)
  },
  
  computed: {
    cart () {
      return this.$store.state.cart
    }
  },
  
  methods: {    
    removeCartItem (index, key, title) {
      this.removeButton = true

      if (confirm("Press OK if you want to delete " + title + " from cart")) {
        window.axios.delete('/api/cart/' + key)
          .then((res) => {
            this.$store.commit('setCart', res.data)
            this.removeButton = false
          })
          .catch((error) => {
            this.$store.commit('setPopup', {
              open: true,
              content: '<p>' + error.response.data.message + '</p>'
            }) 
            this.removeButton = false
          })
      } else {
        this.removeButton = false
      }
    },

    updateQuantity (symbol, index) {
      if (symbol == '+') {
        this.cart.items[index].qty++
        this.updateItemsQuantity(index)
      } else {
        this.cart.items[index].qty--
        this.updateItemsQuantity(index)
      }
    },

    updateItemsQuantity (index) {
      this.$store.commit('setLoading', true)
      
      let quantity = parseInt(this.cart.items[index].qty)
      this.quantityInput = true

      // make sure quantity is not less than 1
      if (quantity < 1) {
        this.removeCartItem (index, this.cart.items[index].key, this.cart.items[index].title)
        return
        //this.cart.items[index].qty = 1
      }

      // update item quantity
      let payload = {
        key: this.cart.items[index].key,
        id: this.cart.items[index].item_id,
        qty: this.cart.items[index].qty,
        updateQty: false
      }

      window.axios.put('/api/cart', payload)
        .then((res) => {
          this.$store.commit('setLoading', false)
          this.$store.commit('setCart', res.data)
          this.quantityInput = false
        })
        .catch((error) => {
          this.$store.commit('setLoading', false)
          this.$store.commit('setPopup', {
            open: true,
            content: '<p>' + error.response.data.message + '</p>'
          })
          this.quantityInput = false
        })
    }
  },
};
</script> 

<style scoped lang="scss">
@import "../../sass/core/variables.scss";

.cart-section {
	position: fixed;
  top: 0;
  right: 0;
  z-index: 9999;

  width: 100%;
  height: 100vh;

  .background {
    position: absolute;
    top: 0 !important;
    left: 0;

    height: 100%;
  }

  .wrap {
    position: relative;
    z-index: 9;

    width: 90%;
    max-width: 650px;
    height: 100vh;
    padding: 20px;
    margin: 0 0 0 auto;

    background: white;

    @media (min-width: $mediumish) {
      padding: 45px 50px;
    }

    h3 {
      font-size: 24px;
    }

    .close {
      position: absolute;
      top: 10px;
      right: 0;

      cursor: pointer;

      @media (min-width: $mediumish) {
        top: 43px;
        right: 40px;
      }

      span {
        font-size: 26px;
        color: black;
      }
    }

    .list {
      article {
        padding: 10px 0 16px;
        border-bottom: 1px solid #D7D7D7;

        .product {
          max-width: 324px;
          margin-bottom: 10px;

          @media (min-width: $mediumish) {
            margin-bottom: 0;
          }
        
          img.hero {
            width: 80px;
            height: 80px;
            object-fit: contain;
            border: 1px solid #D8D8D8;
          }

          .info {
            max-width: calc(100% - 80px);
            width: 244px;
            padding: 0 20px 0 14px;

            h5 {
              margin: 0;

              font-size: 14px;
              font-weight: 400;
              line-height: 20px;
              color: #3B3E40;
            }
          }
        }

        .quantity {
          width: 138px;
        }

        .price {
          width: 88px;
          
          p {
            margin: 0;
            font-size: 16px;
            line-height: 26px;
            text-align: right;
            color: #3B3E40;
          }
        }
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// resources/assets/frontend/js/modulatte-cart/Cart.vue